module.exports = __webpack_public_path__ + "static/media/81.f89a4920.gif";